import { useEffect, useState } from 'react';
import { getBrowser, getOS } from '@medflex/utils/getClientInfo';

const useCallReports = () => {
  const [reports, setReports] = useState([]);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const rs = localStorage.getItem('callReports');
    setReports(rs ? JSON.parse(rs) : []);
    setInitialized(true);
  }, []);

  useEffect(() => {
    if (initialized) {
      localStorage.setItem('callReports', JSON.stringify(reports));
    }
  }, [reports]);

  const create = ({ log, call, devices }) => {
    const report = {
      id: call.id,
      date: new Date().toJSON(),
      userAgent: navigator && navigator.userAgent,
      OS: getOS() || undefined,
      browser: getBrowser() || undefined,
      errorLog: log,
      ...(call && {
        callId: call.id,
        sessionId: call.sessionId,
        establishedAt: call.establishedAt,
        endedAt: call.endedAt,
        scheduledAt: call.scheduledAt,
      }),
      devices,
    };

    setReports([report]);

    const index = reports.findIndex(({ callId }) => callId === call.id);
    if (index !== -1) {
      const tmp = [...reports];
      tmp[index] = report;
      setReports(tmp);
    } else {
      setReports([...reports, report]);
    }

    return report;
  };

  return { create, reports };
};

export default useCallReports;
